var _path, _path2, _path3;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgImgicon(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.6528 1.99805H3.3299C2.59434 1.99805 1.99805 2.59434 1.99805 3.3299V12.6528C1.99805 13.3884 2.59434 13.9847 3.3299 13.9847H12.6528C13.3884 13.9847 13.9847 13.3884 13.9847 12.6528V3.3299C13.9847 2.59434 13.3884 1.99805 12.6528 1.99805Z",
    stroke: "#99A1AF",
    strokeWidth: 1.33185,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M5.99298 7.32483C6.72854 7.32483 7.32483 6.72854 7.32483 5.99298C7.32483 5.25742 6.72854 4.66113 5.99298 4.66113C5.25742 4.66113 4.66113 5.25742 4.66113 5.99298C4.66113 6.72854 5.25742 7.32483 5.99298 7.32483Z",
    stroke: "#99A1AF",
    strokeWidth: 1.33185,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M13.984 9.98894L11.9289 7.93389C11.6792 7.68421 11.3405 7.54395 10.9873 7.54395C10.6342 7.54395 10.2955 7.68421 10.0457 7.93389L3.99512 13.9845",
    stroke: "#99A1AF",
    strokeWidth: 1.33185,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgImgicon);
export default __webpack_public_path__ + "static/media/imgicon.fa2d210f3b74ba26f110c03451234061.svg";
export { ForwardRef as ReactComponent };